export { default } from './stickyWrap';